export const blockIconsTransportationElectricCarNew = (
	<span className='material-symbols-outlined'>electric_car</span>
);
